import { useProviderViewWaitingPatients } from '../useProviderViewWaitingPatients';
import {
  useChatMessagesToast,
  type UseChatMessagesToastProps,
} from './useChatMessagesToast';

type UseProviderChatMessagesToastProps = Omit<
  UseChatMessagesToastProps,
  'findSender'
>;

export const useProviderChatMessagesToast = (
  props: UseProviderChatMessagesToastProps,
) => {
  const { waitingPatients } = useProviderViewWaitingPatients();
  return useChatMessagesToast({
    ...props,
    findSender: (message) =>
      waitingPatients.find(
        (participant) => participant.chatUserId === message.senderId,
      ),
  });
};
